import { render, staticRenderFns } from "./CortexIcon.vue?vue&type=template&id=60a93c1f&scoped=true"
import script from "./CortexIcon.vue?vue&type=script&lang=js"
export * from "./CortexIcon.vue?vue&type=script&lang=js"
import style0 from "./CortexIcon.vue?vue&type=style&index=0&id=60a93c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a93c1f",
  null
  
)

export default component.exports